import React, { useEffect, useState } from 'react'
import { DemandType } from '.././DemandModal'
import ModalWrap from '.././index'
import classes from '.././Modal.module.css'
import Input from '.././../Select/Input'
import BlueBtn from '../../SidBarButtons/BlueBtn'
import { IoMdSave } from 'react-icons/io'
import { toast } from 'react-toastify'
import { direction } from './../../../store/direction'
import http from './../../../Service/http'
import { useTranslation } from 'react-i18next'
import { auth } from '../../../store/auth'

function AcademModal({ isOpen, setIsOpen, stud }: DemandType) {
	const [valueRU, setValueRU] = useState<string>('')
	const [valueKg, setValuekg] = useState<string>('')
	const [valueEn, setvalueEn] = useState<string>('')
	const notify = (title: string) => toast(title)

	useEffect(() => {
		if (!isOpen) {
			setValuekg('')
			setvalueEn('')
			return
		}
		if (direction.leftOrRight == 'left') {
			setValueRU(stud.insert_pole)
			setValuekg(stud.insert_pole_kg)
		} else {
			setValueRU(stud.p24)
			setValuekg(stud.p24_kg)
			setvalueEn(stud.p24_en)
		}
	}, [isOpen])

	async function hundleClick() {
		if (direction.leftOrRight == 'left') {
			const result = await http.put('/addition/okno', {
				insert_pole: valueRU,
				insert_pole_kg: valueKg,
				id_okno_dopolnitelno: stud.id
			})
			if (result.data.result) {
				notify('Успешно')
				setIsOpen()
				const res = await http.get('/addition/okno')
				direction.newDops(res.data.Okno_dopolnitelno)
			}
			return
		}

		if (direction.sdd === 1) {
			const result = await http.put('/addition/direction', {
				id_AVN_User: auth.user.data.id,
				setAcademKG: valueKg,
				setAcademEN: valueEn,
				id_direction: stud.id_direction
			})
			if (result.data.result) {
				notify('Успешно')
				setIsOpen()
				const res = await http.get('/addition/direction?search_direction=' + direction.sddText + '&pageNum=' + direction.page)
				direction.newAcadem(res.data.DirectionList)
				setValueRU('')
				setValuekg('')
				setvalueEn('')
			}
		} else if (direction.sdd === 2) {
			const result = await http.put('/addition/special', {
				id_AVN_User: auth.user.data.id,
				setAcademKG: valueKg,
				setAcademEN: valueEn,
				id_special: stud.id_special
			})
			if (result.data.result) {
				notify('Успешно')
				setIsOpen()
				const res = await http.get('/addition/special?search_direction=' + direction.sddText + '&pageNum=' + direction.page)
				direction.newAcadem(res.data.SpecialList)
				setValueRU('')
				setValuekg('')
				setvalueEn('')
			}
		} else if (direction.sdd === 3) {
			const result = await http.put('/addition/discipline', {
				id_AVN_User: auth.user.data.id,
				setAcademKG: valueKg,
				setAcademEN: valueEn,
				id_discipline: stud.id_discipline
			})
			if (result.data.result) {
				notify('Успешно')
				setIsOpen()
				const res = await http.get('/addition/discipline?search_direction=' + direction.sddText + '&pageNum=' + direction.page)
				direction.newAcadem(res.data.DisciplineList)
				setValueRU('')
				setValuekg('')
				setvalueEn('')
			}
		}
	}
	const { t } = useTranslation()

	return (
		<>
			<ModalWrap isOpen={isOpen} setIsOpen={setIsOpen} id={12} title={'Добавить новую'}>
				<div className={classes.account} style={{ width: '860px' }}>
					<div className='edit' style={{ width: '100%', maxWidth: '100%', padding: '0', flexDirection: 'column' }}>
						<Input
							title={'На русском'}
							style={{ width: '100%' }}
							type='text'
							placeholder='Введите текст'
							value={valueRU}
							oninput={(str: string) => {
								setValueRU(str)
							}}
						/>
						<Input
							title={'Кыргызча'}
							style={{ width: '100%' }}
							type='text'
							placeholder='Введите текст'
							value={valueKg}
							oninput={(str: string) => {
								setValuekg(str)
							}}
						/>
						<Input
							title={'Ehglish'}
							style={{ width: '100%' }}
							type='text'
							placeholder='Введите текст'
							value={valueEn}
							oninput={(str: string) => {
								setvalueEn(str)
							}}
						/>
					</div>
					<div className={classes.docRegisBtn}>
						<BlueBtn title={t('st:button.save')} onclick={hundleClick}>
							<IoMdSave />
						</BlueBtn>
					</div>
				</div>
			</ModalWrap>
		</>
	)
}

export default AcademModal
